import {
  Button,
  IconButton,
  Modal,
  TextareaAutosize
} from '@mui/material';
import {
  Close
} from '@mui/icons-material';
import Loading from "components/Loading";
import React from "react";
import styled from "styled-components";
import COLOR from "utils/constants/color";

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  @media only screen and (max-width: 600px) {
    min-width: 90% !important;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const TitleTextCover = styled.span`
  font-size: 14px;
  color: black;
  font-weight: 600;
  // margin-left:5px;
  // margin-top:5px;
`;
const TextAreaAuto = styled(TextareaAutosize)`
    height: 350px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: scroll;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;

const EditModal = ({open, onClose, setContent,content,handlerSave,loading, title="Edit Article"}) => {
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        style={{ height: "100%", width: "100%" }}
        disableEscapeKeyDown
        disableBackdropClick
      >
        <ModalContent>
          <TitleTextCover>{title}</TitleTextCover>
          <IconButton
            onClick={onClose}
            style={{ padding: 0, position: "absolute", right: 0, top: 0 }}
          >
            <Close color="secondary" />
          </IconButton>
          {loading && <Loading />}
          <ModalConfigArea className='editModalTxtArea'>
            <TextAreaAuto
              id="Transcript"
              name="Transcript"
              label="Transcript"
              InputLabelProps={{ shrink: true, required: true }}
              type="text"
              variant="outlined"
              margin="normal"
              onChange={(e) => setContent(e.target.value)}
              value={content}
              style={{ maxHeight: "50vh", minHeight: "350px", overflow: "scroll" }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handlerSave}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          </ModalConfigArea>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EditModal;
